import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import {renderFieldSelect} from '../../util/inputs';
import {alterarPrestadorItinerarioEmLote} from '../../actions/itinerario/alterarPrestadorItinerarioEmLote';
import {showSuccessMsg} from '../../util/messagesUtil';
import moment from 'moment';
import DatePicker, {registerLocale, setDefaultLocale} from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import DiasSemanaSelector from './DiasSemanaSelector';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export class ModalAlteracaoPrestadorItinerarioEmLote extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.state = {dataInicio: null, dataFim: null, diasSelecionados: []}

    }

    buscarItinerarios() {
        this.props.buscarItinerarios();
    }

    montarParametroItinerario(values) {
        return {
            dataInicio: moment(this.state.dataInicio).format('YYYY-MM-DD'),
            dataFim: moment(this.state.dataFim).format('YYYY-MM-DD'),
            idPrestador: values.prestador ? values.prestador.value : null,
            empresaId: this.props.empresaSelecionada.id,
            diasSelecionados: this.state.diasSelecionados ? this.state.diasSelecionados: [],
            idRota: this.props.rotaSelecionada.value
        }
    }

    fecharModal() {
        $('#modalAlteracaoPrestadorItinerarioEmLote')
            .modal('hide');
        $('#modalAlteracaoPrestadorItinerarioEmLote')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    submit(values) {
        const parametros = this.montarParametroItinerario(values)
        this.props.alterarPrestadorItinerarioEmLote(parametros)
            .then(() => {
                showSuccessMsg('Operação realizada com sucesso');
                this.fecharModal();
                this.buscarItinerarios()
            })
    }


    limparFormulario() {
        this.props.reset('formularioAlteracaoPrestadorItinerarioEmLote');
        this.setState({dataInicio: null, dataFim: null});
    }


    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({dataInicio: data, dataFim: null})
        } else {
            this.setState({data, dataFim: data})
        }
    }


    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        minDate.setDate(minDate.getDate() - 5)
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }


    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <div className="modal fade show" id='modalAlteracaoPrestadorItinerarioEmLote' role='dialog'
                 aria-labelledby='modalAlteracaoPrestadorItinerarioEmLote' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">person</i>
                                <span className="vx-modal-title">Alterar Prestador em lote</span>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            <form id="form-alterar-prestador-em-lote" onSubmit={handleSubmit(this.submit)}>
                                <div className="col-12 col-sm-4 col-md-4 mt-2">
                                      <label>Opera em quais dias da semana?</label>
                                      <DiasSemanaSelector
                                        diasSelecionados={this.state.diasSelecionados}
                                        onChange={(novosDias) => this.setState({ diasSelecionados: novosDias })}
                                      />
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data de início</label>
                                        {this.exibirCalendario(true)}
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data fim</label>
                                        {this.exibirCalendario()}
                                    </div>
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                <Field name='prestador'
                                                       options={this.props.prestadoresSimples.map(elemento => ({
                                                           descricao: elemento.valor,
                                                           nome: elemento.chave
                                                       }))}
                                                       component={renderFieldSelect}
                                                       label="Prestador"
                                                       placeholder='Selecione um prestador'/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="vx-modal-footer">
                            <button type="submit" form="form-alterar-prestador-em-lote"
                                disabled={invalid || submitting || !this.state.dataInicio || !this.state.dataFim}
                                className="vx-btn-primary">
                                <i className="material-icons" style={{ fontSize: '16px' }}>save</i> Salvar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            prestador: {label: 'Frota própria', value: ''}
            },
        prestador: formValueSelector('formularioAlteracaoPrestadorItinerarioEmLote')(state, 'prestador'),
        empresaSelecionada: state.empresaSelecionada,
        itinerarioSelecionado: state.itinerarioSelecionado,
        tiposPreco: state.tiposPreco,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        rotaSelecionada: state.rotaSelecionada,
        prestadoresSimples: state.prestadores.prestadoresSimples


    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        alterarPrestadorItinerarioEmLote
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioAlteracaoPrestadorItinerarioEmLote',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalAlteracaoPrestadorItinerarioEmLote));
